import React from 'react';
import SnapshotCardBase from './SnapshotCardBase';

const formatTry = (value) => `${Number(value || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} TL`;

export default function ExpertSnapshotCard({ data, onOpenDrawer }) {
  return (
    <SnapshotCardBase
      title="Uzman"
      help={{
        description: 'Uzman katmanının aktiflik ve gelir etkisini hızlıca gösterir.',
        interpretation: 'Aktif uzman sayısı sabitken gelir düşüyorsa eşleşme kalitesi izlenmelidir.',
        metricExample: 'Aktif uzman artarken impact düşerse low-sample guard kontrol edilir.'
      }}
      primary={Number(data?.activeExperts || 0).toLocaleString('tr-TR')}
      metrics={[
        { label: 'Toplam Uzman', value: Number(data?.totalExperts || 0).toLocaleString('tr-TR') },
        { label: 'Aylık Gelir', value: formatTry(data?.monthlyRevenueTry) },
        { label: 'Impact Ort.', value: Number(data?.averageImpactScore || 0).toLocaleString('tr-TR') }
      ]}
      onOpenDrawer={onOpenDrawer}
    />
  );
}
